import { validateRecaptcha } from '../../../../../../../api/rest/validateRecaptcha';
import { authenticateWithEmailAndPassword } from '../../../../../../../helpers/authentication/authentication';
import { Context } from '../../types';

interface AuthenticationArgs {
  helpers: Pick<Context['helpers'], 'checkForTokens' | 'getToken'>;
  standardAuth: Pick<Context['standardAuth'], 'account' | 'reCaptcha'>;
}

export const handleStandardAuth = async ({
  helpers,
  standardAuth,
}: AuthenticationArgs): Promise<void> => {
  const { checkForTokens, getToken } = helpers;
  const { account, reCaptcha } = standardAuth;
  const { email, password } = account;
  const { ref } = reCaptcha;
  const reCaptchaToken = await ref.current.executeAsync();

  await validateRecaptcha(reCaptchaToken, 'mykiss_invisible', getToken);
  await authenticateWithEmailAndPassword(email, password);
  await checkForTokens();
};
